<template>
    <div>
        <v-btn color="light-blue darken-3" @click="authenticate('vk')" dark>
            <v-icon left dark>mdi-vk</v-icon>
            Войти через Вконтакте
        </v-btn>
        <v-btn color="red" @click="signInWithGoogle" dark>
            <v-icon left dark>mdi-google</v-icon>
            Войти через Google
        </v-btn>
    </div>
</template>

<script>
    import Vue from 'vue'

    import firebase from 'firebase/app'
    import 'firebase/auth'


    import VueAxios from 'vue-axios'
    import axios from 'axios';

    Vue.use(VueAxios, axios);
    import VueAuthenticate from 'vue-authenticate'

    Vue.use(VueAuthenticate, {
        providers: {
            vk: {
                name: 'vk',
                url: '/auth/vk',
                clientId: '6838512',
                responseType: 'token',
                redirectUri: window.location.protocol+'//'+window.location.host+'/',
                authorizationEndpoint: 'https://oauth.vk.com/authorize',
                requiredUrlParams: ['display', 'scope'],
                scope: ['email'],
                scopeDelimiter: ',',
                display: 'popup',
                oauthType: '2.0',
                popupOptions: {width: 580, height: 400}
            }
        }
    });

    export default {
        props: {},
        data() {
            return {}
        },
        mounted() {

        },

        computed: {},
        methods: {

            authenticate(provider) {

                //протокол jsonp кросс доменных запросов к Vk
                function jsonp(url, callback) {
                    const callbackName = 'jsonp_callback_' + Math.round(100000 * Math.random());
                    window[callbackName] = function (data) {
                        delete window[callbackName];
                        document.body.removeChild(script);
                        callback(data);
                    };
                    const script = document.createElement('script');
                    script.src = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'callback=' + callbackName;
                    document.body.appendChild(script);
                }

                this.$auth.authenticate(provider).then((data) => {
                    jsonp(`https://api.vk.com/method/users.get?user_ids=${data.user_id}&fields=bdate,photo_50&access_token=${data.access_token}&v=5.92`,
                        userData => {
                            axios.post(process.env.VUE_APP_FIREBASE_FUNCTION_TOKEN_URL, Object.assign(data, userData.response[0]))
                                .then(({data}) => data)
                                .then(data => {
                                    if (data.token)
                                        firebase.auth().signInWithCustomToken(data.token)
                                            .then(() => this.$router.replace('/'))
                                            .catch(error => console.log(error));
                                })
                                .catch((error) => console.log(error));
                        }
                    )
                })
            },
            signInWithGoogle() {
                const provider = new firebase.auth.GoogleAuthProvider();
                firebase.auth().signInWithPopup(provider).then((result) => {
                    this.$router.replace('/');
                }).catch((err) => {

                });
            }
        },

        components: {

        }
    }
</script>

<style scoped>

</style>
